import useSWR from 'swr';
import { useCustomMutation } from '../../utils/useCustomMutation';
import { Loading, Toggle } from 'carbon-components-react';
import { postMethod } from '../../api/common';
import { ConfirmModal } from '../../components/modal/confirm-modal/ConfirmModal.component';

export function LinkAttendanceToGradingModal({ isOpen, closeModal }) {
  return (
    <ConfirmModal
      title="Link Attendance To Reports"
      isOpen={isOpen}
      closeModal={closeModal}
      secondaryActionText="Close"
      secondaryBtnClasses="secondary"
      description={
        <>
          <LinkAttendanceToGrading isOpen={isOpen} />
        </>
      }
    />
  );
}

export function LinkAttendanceToGrading({ isOpen }) {
  const { data, mutate, isLoading } = useSWR(
    isOpen
      ? `students-attendance/retrieve-attendance-report-configuration`
      : null,
  );
  const linkAttendanceToGrading = data?.response?.linkAttendanceToReport;

  const { trigger, isMutating, error } = useCustomMutation(
    `students-attendance/update-attendance-report-configuration `,
    (url, { arg }) => postMethod(url, arg),
  );

  const isRunning = isLoading || isMutating;
  return (
    <div>
      <div
        className="mt-30 d-flex-space-between"
        style={{
          gap: '10px',
          alignItems: 'center',
        }}
      >
        <p>Link Attendance To Reports</p>
        <div
          style={{
            maxWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          {isRunning ? (
            <Loading
              small={true}
              withOverlay={false}
              style={{ alignSelf: 'end', marginBottom: '4px' }}
            />
          ) : (
            <div style={{ marginTop: '-20px' }}>
              <Toggle
                size="md"
                id="linkAttendanceToGrading"
                labelText=""
                labelA=""
                labelB=""
                toggled={linkAttendanceToGrading}
                onToggle={(value) => {
                  trigger(
                    {
                      linkAttendanceToReport: value,
                    },
                    {
                      onSuccess: () => {
                        mutate();
                      },
                    },
                  );
                }}
              />
            </div>
          )}
        </div>
      </div>

      {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}
    </div>
  );
}
